import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';

/**
 * Persistent notice shown while teen mode (14+) is active, so guardians and
 * schools can see at a glance that the content set has been filtered.
 */
const TeenModeBanner: React.FC = () => {
  const { t } = useTranslation('therapyLibrary');

  return (
    <div className="mb-8 flex items-start gap-3 rounded-lg border border-[hsl(var(--primary)/0.35)] bg-[hsl(var(--primary)/0.07)] px-4 py-3">
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--primary))]" aria-hidden="true" />
      <div className="font-sans text-xs leading-relaxed text-stone-700">
        <p className="font-semibold text-stone-900">
          {t('teen.bannerTitle', { defaultValue: 'Teen mode (14+) is on' })}
        </p>
        <p className="mt-1">
          {t('teen.bannerBody', {
            defaultValue:
              'Entries are limited to age-appropriate, non-spiritual modalities. Some entries require guardian awareness.',
          })}
        </p>
      </div>
    </div>
  );
};

export default TeenModeBanner;
